import { alpha } from '@material-ui/core/styles/colorManipulator';
import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) {
  return {
    root: {
      '&:nth-child(even)': {
        backgroundColor: function (props) {
          return props.zebra ? theme.palette.neutral.iceberg : 'inherit';
        }
      },
      '&$selected': {
        backgroundColor: alpha(theme.palette.denim[100], 0.5)
      },
      '&$hover:hover': {
        backgroundColor: theme.palette.denim[100]
      }
    },
    hover: {},
    selected: {}
  };
}, {
  name: 'pds-table__row'
});